import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {CardObject, useTopicExplanationsQuery} from "../../../../types.d";
import {ExplanationThumb} from "../../stats/cards/ExplanationThumb";
import {Link} from "react-router-dom";

export const TopicExplanations = (props: RouteComponentProps<{ topic: string }>) => {
    const explanations = useTopicExplanationsQuery({
        variables: {
            topic: Number(props.match.params.topic)
        }
    });

    if (!explanations.data) {
        return <h2>Loading...</h2>
    }

    return <div className={'mx-2'}>
        <Link to={`${props.match.url}/create`} className={'btn btn-primary'}>Create explanation card</Link>

        <div className={'row d-flex pt-2 pb-5'}>
            { explanations.data.topicExplanations.map(item => (
                <ExplanationThumb
                    baseUrl={`${props.match.url}`}
                    key={item.id}
                    card={item as CardObject} />
            )) }
        </div>
    </div>
};
